import type { ProfileStatusMap } from '~/types';

export const profileStatusMap: ProfileStatusMap = {
  AWAITING_INFORMATION: {
    card: {
      title: 'informationCollection',
      icon: 'InfoOutline',
      image: 'FillOut'
    },
    alert: {
      theme: 'warning',
      icon: 'InfoOutline'
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  CREATION_IN_PROGRESS: {
    card: {
      title: 'informationCollection',
      icon: 'InfoOutline',
      image: 'FillOut'
    },
    alert: {
      theme: 'info',
      icon: null
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  INFORMATION_COLLECTION_IN_PROGRESS: {
    card: {
      title: 'informationCollection',
      icon: 'InfoOutline',
      image: 'FillOut'
    },
    alert: {
      theme: 'info',
      icon: null
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  IDENTITY_VERIFICATION_IN_PROGRESS: {
    card: {
      title: 'idVerification',
      icon: 'AccountCircle',
      image: 'Selfie'
    },
    alert: {
      theme: 'info',
      icon: null
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  IDENTITY_VERIFICATION_ABANDONED: {
    card: {
      title: 'idVerification',
      icon: 'AccountCircle',
      image: 'Selfie'
    },
    alert: {
      theme: 'info',
      icon: null
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  IDENTITY_VERIFICATION_ERROR: {
    card: {
      title: 'idVerification',
      icon: 'AccountCircle',
      image: 'Selfie'
    },
    alert: {
      theme: 'info',
      icon: null
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  IDENTITY_VERIFICATION_IN_ERROR: {
    card: {
      title: 'idVerification',
      icon: 'AccountCircle',
      image: 'Denied'
    },
    alert: {
      theme: 'danger',
      icon: 'Close'
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  UNDER_ANALYSIS: {
    card: {
      title: 'lemonwayReview',
      icon: 'Check',
      image: 'Oversight'
    },
    alert: {
      theme: 'info',
      icon: 'Clock',
      caption: true
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  },
  ACCEPTED: {
    card: {
      title: 'lemonwayReview',
      icon: 'Check',
      image: 'Winners'
    },
    alert: {
      theme: 'success',
      icon: 'Check'
    },
    chip: {
      theme: 'success',
      icon: 'Check'
    }
  },
  DENIED: {
    card: {
      title: 'lemonwayReview',
      icon: 'Check',
      image: 'Denied'
    },
    alert: {
      theme: 'danger',
      icon: 'Close'
    },
    chip: {
      theme: 'danger',
      icon: 'Block'
    }
  },
  REJECTED: {
    card: {
      title: 'lemonwayReview',
      icon: 'Check',
      image: 'Analyze'
    },
    alert: {
      theme: 'warning',
      icon: 'InfoOutline'
    },
    chip: {
      theme: 'warning',
      icon: 'Clock'
    }
  }
};
